export default {
  title: 'Hoeveel en welke aandelen worden er overgedragen?',
  description:
    'Vul hier de gegevens in over de aandelen die door verkoper worden overgedragen aan koper. Controleer of je de gegevens compleet en juist hebt ingevuld. Zo kunnen wij jou zo snel mogelijk van dienst zijn.',
  number_of_shares: '',
  shareholders: 'Koper ontvangt aandelen ter waarde van',
  warning:
    'Bij een hoog aandelenkapitaal moet de notaris extra werkzaamheden verrichten. Zo geldt er vanaf een aandelenkapitaal van €10.000 een wettelijke onderzoeksplicht voor de notaris naar de herkomst van het vermogen. Omdat dit maatwerk betreft is het via Ligo niet mogelijk om een B.V. op te richten met een aandelenkapitaal hoger dan €10.000. Voor meer informatie kun je met ons contact opnemen via 020-3031043.'
};
